import "../../../assets/css/Heatmap/heatmapModal.css";
import { useSelector } from "react-redux";

const Loader = ({ children }) => {
  const { heatmapLoader, loaderText } = useSelector((state) => state.heatmap);
  return (
    <div className="heat-map-loader">
      {heatmapLoader ? (
        <div className="spinner-wrapper">
          <h3>{loaderText}</h3>
          {loaderText.includes("No Data") ? (
            <h3 className="loader-text">
              Please select a different Timerange!
            </h3>
          ) : null}
          {loaderText.includes("No Data") ? null : (
            <div className="spinner"></div>
          )}
        </div>
      ) : null}
      {children}
    </div>
  );
};

export default Loader;
